import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatComponent } from '@features/chat/chat.component';
import { ChatService } from '@features/chat/services/chat.service';
import { DepositService } from '@features/deposit/services/deposit.service';
import { HeaderComponent } from '@features/header/header.component';
import { LeaderboardService } from '@features/leaderboard/services/leaderboard.service';
import { RewardsService } from '@features/rewards/services/rewards.service';
import { SessionService } from '@core/services/session.service';
import { UIService } from '@core/services/ui.service';
import { LiveBetsService } from '@features/live-bets/services/live-bets.service';
import { GamesService } from '@core/services/games.service';
import { CoinflipDeprecatedService } from '@old-app/coinflip/coinflip.service';
import { PlinkoService } from '@old-app/plinko/plinko.service';
import { JackpotHrService } from '@old-app/jackpot/jackpot-hr.service';
import { UpgraderService } from '@old-app/upgrader/upgrader.service';
import { WheelService } from '@old-app/wheel/wheel.service';
import { TowersService } from '@old-app/towers/towers.service';
import { MinesService } from '@old-app/mines/mines.service';
import { CaseBattlesService } from '@features/case-battles/case-battles.service';
import { SocketService } from '@core/services/socket.service';
import { KingService } from '@old-app/king/king.service';
import { CasesService } from '@features/cases/services/cases.service';
import { AffiliatesService } from '@features/affiliates/services/affiliates.service';
import { GiveawaysService } from '@features/giveaways/giveaways.service';
// import { SupportService } from '@features/support/services/support.service';
import { MaintenanceService } from '@core/services/maintenance.service';
import { fadeInAnimation } from '@core/utils/animations.util';
import { SvgIconComponent } from 'angular-svg-icon';
import { DISCORD_LINK } from '@core/constants/discord.constants';
import { WithdrawService } from '@features/withdraw/withdraw.service';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, ChatComponent, SvgIconComponent],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInAnimation,
    trigger('chat', [
      state(
        'closed',
        style({
          transform: 'translateX(100%)',
          opacity: 0,
        })
      ),
      state(
        'open',
        style({
          opacity: 1,
          transform: 'translateX(0)',
        })
      ),
      transition('closed => open', [
        animate('0.3s ease', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition('open => closed', [
        animate(
          '0.3s ease',
          style({ transform: 'translateX(100%)', opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class AppComponent {
  public readonly DISCORD_LINK = DISCORD_LINK;
  public readonly version = environment.version;

  constructor(
    private socketService: SocketService,
    public uiService: UIService,
    private sessionService: SessionService,
    private chatService: ChatService,
    private casesService: CasesService,
    private caseBattlesService: CaseBattlesService,
    private leaderboardService: LeaderboardService,
    private liveBetsService: LiveBetsService,
    private rewardsService: RewardsService,
    private depositService: DepositService,
    private gamesService: GamesService,
    private deprecatedCoinflipService: CoinflipDeprecatedService,
    private plinkoService: PlinkoService,
    private jackpotHrService: JackpotHrService,
    private upgraderService: UpgraderService,
    private kingService: KingService,
    private wheelService: WheelService,
    private towersService: TowersService,
    private minesService: MinesService,
    private affiliatesService: AffiliatesService,
    private giveawayService: GiveawaysService,
    // private supportService: SupportService,
    public maintenanceService: MaintenanceService,
    private withdrawService: WithdrawService
  ) {}
}
